<template>
  <div class="productDetailBox">
    <div class="productDetail">
      <h1 class="title">{{ dataObj.title }}</h1>
      <div class="bigBox">
        <div class="blBox">
          <img class="img" :src="dataObj.img" alt="" />
        </div>
        <div class="brBox">
          <div class="brtBox">{{ dataObj.chipset }}</div>
          <div class="brbBpx">
            <div class="brbLeft">
              <div class="text">
                <h5>Network Mode</h5>
                <p>{{ dataObj.nextwork }}</p>
              </div>
              <div class="text">
                <h5>Bands</h5>
                <p v-for="(item, index) in dataObj.bands" :key="index">
                  {{ item }}
                </p>
              </div>
              <div class="text" v-if="dataObj.battery">
                <h5>Battery</h5>
                <p>{{ dataObj.battery }}</p>
              </div>
              <div class="text" v-if="dataObj.power">
                <h5>Power</h5>
                <p>{{ dataObj.power }}</p>
              </div>
              <div class="text" v-if="dataObj.nfc">
                <h5>NFC</h5>
                <p>{{ dataObj.nfc }}</p>
              </div>
              <div class="text" v-if="dataObj.powerInput">
                <h5>Power Input</h5>
                <p>{{ dataObj.powerInput }}</p>
              </div>
            </div>
            <div class="brbRight">
              <div class="text" v-if="dataObj.throughput5">
                <h5>5G Throughput</h5>
                <p v-for="(item, index) in dataObj.throughput5" :key="index">
                  {{ item }}
                </p>
              </div>
              <div class="text" v-if="dataObj.throughput4">
                <h5>4G Throughput</h5>
                <p v-for="(item, index) in dataObj.throughput4" :key="index">
                  {{ item }}
                </p>
              </div>
              <div class="text" v-if="dataObj.mimo5">
                <h5>5G MIMO</h5>
                <p v-for="(item, index) in dataObj.mimo5" :key="index">
                  {{ item }}
                </p>
              </div>
              <div class="text" v-if="dataObj.mimo4">
                <h5>4G MIMO</h5>
                <p v-for="(item, index) in dataObj.mimo4" :key="index">
                  {{ item }}
                </p>
              </div>
              <div class="text" v-if="dataObj.wifi7">
                <h5>WiFi 7</h5>
                <p v-for="(item, index) in dataObj.wifi7" :key="index">
                  {{ item }}
                </p>
              </div>
              <div class="text" v-if="dataObj.wifi6">
                <h5>WiFi 6</h5>
                <p v-for="(item, index) in dataObj.wifi6" :key="index">
                  {{ item }}
                </p>
              </div>
              <div class="text" v-if="dataObj.wifi5">
                <h5>WiFi 5</h5>
                <p v-for="(item, index) in dataObj.wifi5" :key="index">
                  {{ item }}
                </p>
              </div>
              <div class="text" v-if="dataObj.wifi4">
                <h5>WiFi 4</h5>
                <p v-for="(item, index) in dataObj.wifi4" :key="index">
                  {{ item }}
                </p>
              </div>
              <div class="text">
                <h5>Interface</h5>
                <p v-for="(item, index) in dataObj.interface" :key="index">
                  {{ item }}
                </p>
              </div>
            </div>
          </div>
          <img
            v-if="$route.query.id == 303"
            class="interface"
            src="@/assets/interface.png"
            alt=""
          />
        </div>
      </div>
      <div class="footerBox">
        <img class="imgBox" :src="dataObj.footerimg" alt="" />
      </div>
    </div>
    <div class="productDetailTwo">
      <h1 class="title">{{ dataObj.title }}</h1>
      <div class="blBox">
        <img class="img" :src="dataObj.img" alt="" />
      </div>
      <div class="brBox">
        <div class="brtBox">{{ dataObj.chipset }}</div>
        <div class="brbBpx">
          <div class="brbLeft">
            <div class="text">
              <h5>Network Mode</h5>
              <p>{{ dataObj.nextwork }}</p>
            </div>
            <div class="text">
              <h5>Bands</h5>
              <p v-for="(item, index) in dataObj.bands" :key="index">
                {{ item }}
              </p>
            </div>
            <div class="text" v-if="dataObj.battery">
              <h5>Battery</h5>
              <p>{{ dataObj.battery }}</p>
            </div>
            <div class="text" v-if="dataObj.power">
              <h5>Power</h5>
              <p>{{ dataObj.power }}</p>
            </div>
            <div class="text" v-if="dataObj.nfc">
              <h5>NFC</h5>
              <p>{{ dataObj.nfc }}</p>
            </div>
            <div class="text" v-if="dataObj.powerInput">
              <h5>Power Input</h5>
              <p>{{ dataObj.powerInput }}</p>
            </div>
            <div class="text" v-if="dataObj.throughput5">
              <h5>5G Throughput</h5>
              <p v-for="(item, index) in dataObj.throughput5" :key="index">
                {{ item }}
              </p>
            </div>
            <div class="text" v-if="dataObj.throughput4">
              <h5>4G Throughput</h5>
              <p v-for="(item, index) in dataObj.throughput4" :key="index">
                {{ item }}
              </p>
            </div>
            <div class="text" v-if="dataObj.mimo5">
              <h5>5G MIMO</h5>
              <p v-for="(item, index) in dataObj.mimo5" :key="index">
                {{ item }}
              </p>
            </div>
            <div class="text" v-if="dataObj.mimo4">
              <h5>4G MIMO</h5>
              <p v-for="(item, index) in dataObj.mimo4" :key="index">
                {{ item }}
              </p>
            </div>
            <div class="text" v-if="dataObj.wifi7">
              <h5>WiFi 7</h5>
              <p v-for="(item, index) in dataObj.wifi7" :key="index">
                {{ item }}
              </p>
            </div>
            <div class="text" v-if="dataObj.wifi6">
              <h5>WiFi 6</h5>
              <p v-for="(item, index) in dataObj.wifi6" :key="index">
                {{ item }}
              </p>
            </div>
            <div class="text" v-if="dataObj.wifi5">
              <h5>WiFi 5</h5>
              <p v-for="(item, index) in dataObj.wifi5" :key="index">
                {{ item }}
              </p>
            </div>
            <div class="text" v-if="dataObj.wifi4">
              <h5>WiFi 4</h5>
              <p v-for="(item, index) in dataObj.wifi4" :key="index">
                {{ item }}
              </p>
            </div>
            <div class="text">
              <h5>Interface</h5>
              <p v-for="(item, index) in dataObj.interface" :key="index">
                {{ item }}
              </p>
            </div>
          </div>
        </div>
        <img
          v-if="$route.query.id == 303"
          class="interface"
          src="@/assets/interface.png"
          alt=""
        />
      </div>
      <div class="footerBox">
        <img class="imgBox" :src="dataObj.footerimg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
// import { productDetailObj } from '@/static/productsDetail.js'
export default {
  data () {
    return {
      productDetailObj: {},
      dataObj: {}
    }
  },
  created () {
    this.productDetailObj = JSON.parse(
      window.sessionStorage.getItem('productDetailObj')
    )
  },
  mounted () {
    this.dataObj = this.productDetailObj[this.$route.query.id]
    console.log('this.dataObj',this.dataObj)
  }
}
</script>

<style lang="less" scoped>
.productDetailBox {
  .productDetail {
    margin: 0 auto;
    width: 1150px;
    .title {
      font-size: 28px;
      margin-bottom: 30px;
      color: #0057b8;
    }
    .bigBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .blBox {
        width: 520px;
        height: 500px;
        border: 2px solid #c5c5c5;
        border-radius: 20px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        .img {
          width: 600px;
          height: 480px;
        }
      }
      .brBox {
        width: 620px;
        height: 500px;
        background-color: #f2f2f2;
        border-radius: 20px;
        padding: 20px;
        // overflow: hidden;
        .brtBox {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 20px;
        }
        .brbBpx {
          display: flex;
          justify-content: space-between;
          align-content: center;

          .brbLeft {
            width: 400px;
            .text {
              margin-bottom: 30px;
              color: #373737;
              word-wrap: break-word;
              word-break: break-all;
              h5 {
                font-weight: 600;
                font-size: 16px;
                color: #333333;
              }
            }
          }
          .brbRight {
            .text {
              margin-bottom: 30px;
              color: #373737;
              word-wrap: break-word;
              word-break: break-all;
              h5 {
                font-weight: 600;
                font-size: 16px;
                color: #333333;
              }
            }
          }
        }
        .interface {
          width: 580px;
        }
      }
    }
    .footerBox {
      width: 100%;
      height: 370px;
      margin: 50px 0 0 50px;
      .imgBox {
        width: 620px;
        // height: 100%;
      }
    }
  }
  .productDetailTwo {
    margin: 0 auto;
    width: 90%;
    .title {
      font-size: 28px;
      margin: 20px 0;
      color: #0057b8;
    }

    .blBox {
      width: 100%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .img {
        width: 60%;
      }
    }
    .brBox {
      width: 100%;
      padding: 20px 0;
      // overflow: hidden;
      .brtBox {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 20px;
      }
      .brbBpx {
        display: flex;
        justify-content: space-between;
        align-content: center;

        .brbLeft {
          width: 400px;
          .text {
            margin-bottom: 30px;
            color: #373737;
            word-wrap: break-word;
            word-break: break-all;
            h5 {
              font-weight: 600;
              font-size: 16px;
              color: #333333;
            }
          }
        }
        .brbRight {
          .text {
            margin-bottom: 30px;
            color: #373737;
            word-wrap: break-word;
            word-break: break-all;
            h5 {
              font-weight: 600;
              font-size: 16px;
              color: #333333;
            }
          }
        }
      }
      .interface {
        width: 60%;
      }
    }

    .footerBox {
      width: 100%;
      height: 370px;
      // margin: 50px 0 0 50px;
      .imgBox {
        width: 60%;
        // height: 100%;
      }
    }
  }
}
@media screen and (min-width: 1200px) {
  .productDetailBox {
    .productDetailTwo {
      display: none;
    }
  }
}
@media screen and (min-width: 800px) and (max-width: 1200px) {
  .productDetailBox {
    .productDetail {
      display: none;
    }
    .productDetailTwo {
      width: 90%;
      margin: 0 auto;
      .title {
        font-size: 20px;
      }
    }
  }
}
@media screen and (max-width: 800px) {
  .productDetailBox {
    .productDetail {
      display: none;
    }
    .productDetailTwo {
      width: 90%;
      margin: 0 auto;
      .title {
        font-size: 16px;
      }
    }
  }
}
</style>
